import { axiosInstance, axiosFileBlob, live_instance } from "../instance";


// 点播内容列表中：获取分类属性
export const getVodCategoryPropertyApi = (params?) => axiosInstance({
    method: 'get',
    url: `/api/category/getVodCategoryProperty`,
    params
})

// 获取IMDB中的名称的搜索结果
export const getImdbTitleApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getImdbTitle`,
    params,
    noRepetition: true,
})

// 获取IMDB中的名称的搜索详情
export const getImdbDetailInfoByIdApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getImdbDetailInfoById`,
    params,
    noRepetition: true,
})

// 获取TMDB中的名称的搜索结果
export const getTmdbTitleApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getTmdbTitle`,
    params,
    noRepetition: true,
})

// 获取TMDB中的名称的搜索详情
export const getTmdbDetailInfoByIdApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getTmdbDetailInfoById`,
    params,
    noRepetition: true,
})

// 获取ARAB中的名称的搜索结果
export const getArabTitleApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getArabTitle`,
    params,
    noRepetition: true,
})

// 获取ARAB中点击的详细信息
export const getArabDetailInfoByArIdApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getArabDetailInfoByArId`,
    params,
    noRepetition: true,
})

// 新增影片
export const addProgramApi = (data) => {
    return axiosInstance({
        method: 'post',
        url: `/api/vod/addProgram`,
        data,
        type: 'json'
    })
}

// 编辑影片
export const editProgramApi = (data) => {
    return axiosInstance({
        method: 'post',
        url: `/api/vod/editProgram`,
        data,
        type: 'json'
    })
}

// 添加剧集
export const addSeriesEpisodeApi = (data) => {
    return axiosInstance({
        method: 'post',
        url: `/api/vod/addSeriesEpisode`,
        data,
        type: 'json'
    })
}

// 电影 列表添加源地址
export const editMoviePlayUrlApi = (data) => {
    return axiosInstance({
        method: 'post',
        url: `/api/vod/editMoviePlayUrl`,
        data,
        type: 'json'
    })
}

// 获取影片审核列表
export const getReviewListApi = params => axiosInstance({
    method: 'get',
    url: `/api/vod/getReviewList`,
    params,
    noRepetition: true
})

// 获取子品牌分类列表
export const getBrandCategoryListApi = params => axiosInstance({
    method: 'get',
    url: `/api/vod/getBrandCategory`,
    params
})

// 导出
export const exportProgramInfoApi = params => axiosFileBlob({
    method: 'get',
    url: `/api/vod/exportProgramInfo`,
    params,
    timeout: 1800000
})

// 删除
export const deleteVodInfoApi = (data) => {
    const { idLanguageList, ids, programType } = data
    return axiosInstance({
        method: 'delete',
        url: `/api/vod/deleteVodInfo`,
        data: { idLanguageList, ids, programType },
        type: 'json'
    })
}

// 审核: 剧头审核 单个/批量
export const auditStatusApi = (data) => {
    const { auditStatus, ids, programType, remark, ifCheck } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/auditStatus`,
        data: { auditStatus, ids, programType, remark, ifCheck },
        type: 'json'
    })
}

// 审核: 影片审核 单个/批量
export const batchAuditStatusApi = (data) => {
    const { auditStatus, ids, remark, ifCheck, language } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/movieAuditStatus`,
        data: { auditStatus, ids, remark, ifCheck, language },
        type: 'json'
    })
}

// 获取分辨率
export const getBroadCastListApi = params => axiosInstance({
    method: 'get',
    url: `/api/vod/getBroadCastList`,
    params
})

// 上下线
export const onlineOrOfflineStatusApi = (data) => {
    const { id, programType, status } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/OnlineOrOfflineStatus`,
        data: { id, programType, status }
    })
}

// 退回审核
export const returnForReviewApi = (data) => {
    const { id, programType, status } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/returnForReview`,
        data: { id, programType, status }
    })
}

// 搜索字幕
export const searchSubtitleApi = (params?) => axiosInstance({
    method: 'get',
    url: `/api/subtitle/searchSubtitle`,
    params
})

// 获取分类列表
export const getCategoryListApi = (params?) => axiosInstance({
    method: 'get',
    url: `/api/category/getCategoryList`,
    params
})

// 获取子品牌列表
export const getSubAgentApi = (params?) => axiosInstance({
    method: 'get',
    url: `/api/category/getSubAgent`,
    params
})

// 获取类型下拉列表信息
export const getGenresApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vodplus/getGenres`,
    params
})

// 影片审核获取系列片
export const getProgramSetApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getProgramSet`,
    params
})

// 获取影片详情 (回显节目信息)
export const getProgramInfoByIdApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getProgramInfoById`,
    params
})

// 影片 -> 获取影片语言
export const getFilmLanguageApi = (params) => {
    const { id, programType } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getFilmLanguage`,
        params: { id, programType }
    })
}

// 获取影片 -> 电影: 影片播放区 左边中获取《播放地址》
export const getPlayUrlInfoApi = (params) => {
    const { id, language } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getPlayUrlInfo`,
        params: { id, language }
    })
}

// 获取影片 -> 电影 右边数据
export const getProgramInfoApi = (params) => {
    const { id, programType, language, type } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getProgramInfo`,
        params: { id, programType, language, type }
    })
}

// 获取影片->电视剧 右边数据
export const getReviewEpisodeListApi = (params) => axiosInstance({
    method: 'get',
    url: `/api/vod/getReviewEpisodeList`,
    params
})

// 获取影片字幕
export const getReviewSubtitleApi = (params) => {
    const { id, programType, language } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getReviewSubtitle`,
        params: { id, programType, language }
    })
}

// 批量操作 批量上线下线
export const batchReleaseStatusApi = (data) => {
    const { ids, releaseStatus, offlineReason, ifReturn, language } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/movieReleaseStatus`,
        data: { ids, releaseStatus, offlineReason, ifReturn, language },
        type: 'json'
    })
}

// 单个操作 上线下线
export const releaseStatusApi = (data) => {
    const { idLanguageList, ids, programType, releaseStatus, offlineReason, ifReturn } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/releaseStatus`,
        data: { idLanguageList, ids, programType, releaseStatus, offlineReason, ifReturn },
        type: 'json'
    })
}

// 获取详情里面的关联分类
export const getSubCategoryNameApi = (params) => {
    const { categoryIds, cid, type } = params
    return axiosInstance({
        method: 'get',
        url: `/api/category/getSubCategoryName`,
        params: { categoryIds, cid, type },
    })
}

// 新增系列片
export const addProgramSetApi = (data) => {
    const { categoryIds, cid, cpspid, language, name, otherNameList, pictureList, programInfo } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/addProgramSet`,
        data: { categoryIds, cid, cpspid, language, name, otherNameList, pictureList, programInfo },
        type: 'json'
    })
}

// 编辑系列片
export const editProgramSetApi = (data) => {
    const { categoryIds, cid, id, language, name, otherNameList, pictureList, programInfo } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/editProgramSet`,
        data: { categoryIds, cid, id, language, name, otherNameList, pictureList, programInfo },
        type: 'json'
    })
}


// 获取系列片列表
export const getProgramSetListApi = (params) => {
    const { time, categoryIds, page, limit, sortType, sortByField, cid, cpspid, name, codingFormat, releaseStatus, operatingUser, categoryId, language } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getProgramSetList`,
        params: { time, categoryIds, page, limit, sortType, sortByField, cid, cpspid, name, codingFormat, releaseStatus, operatingUser, categoryId, language },
    })
}


// 系列片列表item查看
export const getProgramSetByIdApi = (params) => {
    const { id } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getProgramSetById`,
        params: { id },
    })
}


// 系列影片首页table item单个或者批量删除
export const deleteProgramSetApi = (data) => {
    const { ids } = data
    return axiosInstance({
        method: 'delete',
        url: `/api/vod/deleteProgramSet`,
        data: ids,
        type: 'json'
    })
}


// 系列影片 新增 or 列表中获取影片列表
export const getAddProgramListApi = (params) => {
    const { time, page, limit, sortType, sortByField, cid, cpspid, name, genres, language, programType, releaseStatus, auditStatus, id } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getAddProgramList`,
        params: { time, page, limit, sortType, sortByField, cid, cpspid, name, genres, language, programType, releaseStatus, auditStatus, id },
    })
}


// 系列影片列表 编辑数据列表
export const getAddProgramInfoApi = (params) => {
    const { page, limit, sortType, sortByField, id } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getAddProgramInfo`,
        params: { page, limit, sortType, sortByField, id },
    })
}


// 系列影片列表 批量删除 or 单个移除
export const deleteSetProgramIdsApi = (data) => {
    const { ids, setId } = data
    return axiosInstance({
        method: 'delete',
        url: `/api/vod/deleteSetProgramIds`,
        data: { ids, setId },
        type: 'json'
    })
}


// 列表 双击排序号
export const editSetSequenceApi = (data) => {
    const { categoryId, id, sequence, sequenceBefore } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/editSetSequence`,
        data: { categoryId, id, sequence, sequenceBefore },
        type: 'json'
    })
}


// 列表 添加影片
export const addProgramInfoApi = (data) => {
    const { cid, id, programInfo } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/addProgramInfo`,
        data: { cid, id, programInfo },
        type: 'json'
    })
}


// 影片系列上线或者下线状态
export const programSetStatusApi = (data) => {
    const { ids, offlineReason, releaseStatus } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/programSetStatus`,
        data: { ids, offlineReason, releaseStatus },
        type: 'json'
    })
}

// 系列片导出
export const exportProgramSetApi = params => axiosFileBlob({
    method: 'get',
    url: `/api/vod/exportProgramSet`,
    params
})

// 获取点播相关的语言
export const getVodLanguageApi = () => axiosInstance({
    method: 'get',
    url: `/api/vod/getVodLanguage`,
})

// 根据agent id获取推荐主题(by topic/all)分类
export const getVodplusThemeFixdItemCategoryApi = (params) => {
    const { agentId, type } = params
    return axiosInstance({
        method: 'get',
        url: `/api/category/getVodplusThemeFixdItemCategory`,
        params: {
            agentId,
            type
        }
    })
}

// 提交翻译
export const translateSubtitlesApi = (data) => {
    const { ids, programType } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/translateSubtitles`,
        data: { ids, programType },
        type: 'json'
    })
}

// 媒资管理上传之前判断信息源ID是否存在
export const getMediaSourceIdApi = (params) => {
    const { cpspid, sourceId, programType } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getMediaSourceId`,
        params: {
            cpspid,
            sourceId,
            programType
        }
    })
}

// 媒资管理add to 步骤二内容回显
export const getMediaInfoApi = (params) => {
    const { fileName, url } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/getMediaInfo`,
        params: {
            fileName, url
        }
    })
}

/**======================================== 点播批量操作 ========================================================= */

// 查询搜索结果
export const vodSearchCountApi = (params) => {
    const { id, type, targetAddress } = params
    return axiosInstance({
        method: 'get',
        url: `/api/vod/vodSearchCount`,
        params: { id, type, targetAddress }
    })
}

// 替换
export const replaceVodContentApi = (data) => {
    const { id, type, targetAddress, replaceAddress } = data
    return axiosInstance({
        method: 'post',
        url: `/api/vod/replaceVodContent`,
        data: { id, type, targetAddress, replaceAddress },
        // type: 'json'
    })
}

/**======================================== 内容定价 ========================================================= */
export const getContentApi = (data) => {
    return live_instance({
        method: 'get',
        url: `/agent/content-pricing/config/page`,
        params: data,
        // type: 'json'
    })
}

// 获取内容定价下拉选项
export const getPricingOptionApi = (params) => {
    const { cid } = params
    return axiosInstance(
      {
        method: 'get',
        url: '/api/category/option/content/pricing/agents',
        params: { cid }
      })
}


// 新增内容定价
export const addPricingApi = (data) => {
    return live_instance(
      {
        method: 'post',
        url: '/agent/content-pricing/config',
        data: data,
        type: 'json'
      })
}

// 编辑内容定价
export const editPricingApi = (data) => {
    return live_instance(
      {
        method: 'put',
        url: '/agent/content-pricing/config',
        data: data,
        type: 'json'
      })
}

export const deletePricingApi = (id) => {
    return live_instance(
      {
        method: 'delete',
        url: `/agent/content-pricing/config/${id}`,
      })
}

export const getVodServiceInfoApi = () => {
    return axiosInstance(
        {
          method: 'get',
          url: '/api/otherPayment/getVodServiceInfo',
        })
}
